import { useState, useMemo, useEffect, useCallback } from "react";
function useBooleanQuiz({
  quizId,
  quiz,
  onSolve,
  solveResult,
  showReallyTrue = false,
  isViewSolved = false,
  initialAnswers: initialAnswersProp,
  onAnswerChange
}) {
  var _a;
  const [startTime] = useState(() => Date.now());
  const [isShowingCorrectAnswers, setIsShowingCorrectAnswers] = useState(false);
  const isSolved = solveResult !== null && solveResult !== void 0;
  const shouldShowCorrectAnswers = showReallyTrue || isShowingCorrectAnswers;
  const correctAnswer = ((_a = solveResult == null ? void 0 : solveResult.correctAnswers) == null ? void 0 : _a[0]) === "true";
  const computedInitialSelected = useMemo(() => {
    if (initialAnswersProp !== void 0) {
      return initialAnswersProp.length > 0 ? initialAnswersProp[0] === "true" : null;
    }
    if (isViewSolved && (solveResult == null ? void 0 : solveResult.correctAnswers)) {
      return solveResult.correctAnswers[0] === "true";
    }
    return null;
  }, [isViewSolved, solveResult == null ? void 0 : solveResult.correctAnswers, initialAnswersProp]);
  const [selected, setSelected] = useState(computedInitialSelected);
  const canSubmit = selected !== null;
  useEffect(() => {
    if (selected !== null) {
      onAnswerChange == null ? void 0 : onAnswerChange([selected.toString()]);
    }
  }, [selected, onAnswerChange]);
  const handleSelect = useCallback((value) => {
    if (isSolved || isViewSolved) return;
    setSelected(value);
  }, [isSolved, isViewSolved]);
  const handleSubmit = useCallback(() => {
    if (selected === null || isSolved) return;
    const elapsedTime = Date.now() - startTime;
    onSolve == null ? void 0 : onSolve(quizId, [selected.toString()], quiz.vars, elapsedTime);
  }, [selected, isSolved, startTime, onSolve, quizId, quiz.vars]);
  return {
    selected,
    isSolved,
    canSubmit,
    correctAnswer,
    shouldShowCorrectAnswers,
    isShowingCorrectAnswers,
    setIsShowingCorrectAnswers,
    handleSelect,
    handleSubmit,
    quiz,
    quizId,
    solveResult,
    isViewSolved
  };
}
export {
  useBooleanQuiz
};
//# sourceMappingURL=use-boolean-quiz.js.map
